module.exports = __webpack_public_path__ + "img/11.33cbb4a1.png";